module.exports = __webpack_public_path__ + "img/back10.9fd9d5df.png";